import { render, staticRenderFns } from "./ParcelamentoData.vue?vue&type=template&id=fae88670&"
import script from "./ParcelamentoData.vue?vue&type=script&lang=js&"
export * from "./ParcelamentoData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports